import { render, staticRenderFns } from "./instIcons.vue?vue&type=template&id=a8443148"
import script from "./instIcons.vue?vue&type=script&lang=js"
export * from "./instIcons.vue?vue&type=script&lang=js"
import style0 from "./instIcons.vue?vue&type=style&index=0&id=a8443148&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports